export const isCelsiaSupport = (email?: string | null): boolean => {
  if (!email) return false;
  return email.includes('@celsia');
};

export const CELSIA_SUPPORT_TAG = 'Celsia Support';
